import { UPDATE_DEVICE_TOKEN } from '@/Graphql/mutation';
import { DeviceType } from '@/Types/gql/graphql';
import { authState } from '@/vars/auth';
import { useMutation, useReactiveVar } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getFCMToken } from '../firebase/firebase';

export const usePushNotifications = () => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [updateDeviceToken] = useMutation(UPDATE_DEVICE_TOKEN);
  const { userDetails } = useReactiveVar(authState);

  useEffect(() => {
    const setupPushNotifications = async () => {
      if (typeof window === 'undefined' || !('Notification' in window)) {
        return;
      }

      try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted' && userDetails?._id) {
          const token = await getFCMToken();
          if (token) {
            await updateDeviceToken({
              variables: {
                data: {
                  deviceId: '',
                  deviceToken: token,
                  deviceType: DeviceType.Web,
                },
              },
            });
            setIsSubscribed(true);
          }
        }
      } catch (error) {
        console.error('Error setting up push notifications:', error);
      }
    };
    setupPushNotifications();
  }, [updateDeviceToken, userDetails?._id]);

  return { isSubscribed };
};
